<template>
  <div id="app">
    <!-- nav -->
    <transition name="navfade">
      <header-nav :navIndex="navIndex" v-show="shownav"></header-nav>
    </transition>
    <!-- app main -->
    <transition :name="transitionName">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition :name="transitionName" mode="in-out">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
   
  </div>
</template>

<script>
import HeaderNav from "@c/HeaderNav";

export default {
  name: "App",
  data() {
    return {
      transitionName: "router",
      navIndex: 0
    };
  },
  computed: {
    shownav() {
      return this.$store.state.shownav;
    }
  },
  components: {
    HeaderNav
  },
  watch: {
    $route(to, from) {
      switch (to.path) {
        case "/us":
          this.navIndex = 0;
          break;
        case "/serve":
          this.navIndex = 1;
          break;
        case "/case":
          this.navIndex = 2;
          break;
        case "/contact":
          this.navIndex = 3;
          break;
      }
      if (to.meta.fade == "er") {
        this.transitionName = "toer";
      } else if (to.meta.fade == "detail") {
        this.transitionName = "detail";
      } else if (from.meta.fade == "detail") {
        this.transitionName = "detail";
      } else {
        this.transitionName = "router";
      }
    }
  }
};
</script>
<style lang="scss">

html,body {
  height: 100%;
  background: #000;
  
}
#app {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.clearfix::after {
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
.clearfix {
  zoom: 1;
}
// 整体导航动画
.navfade-enter-active,
.navfade-leave-active {
  transition: all 1s;
}
.navfade-enter,
.navfade-leave-to {
  transform: translate(0, -100%);
  opacity: 0;
}

// 一级页面切换动画
.router-enter-active,
.router-leave-active {
  // transition: all 1s;
}
.router-enter-to,
.router-leave {
  animation: routerPage 1.2s linear;
}

// 进去二级页面的动画
.toer-enter-active,
.toer-leave-active {
  transition: all 0.5s;
}
.toer-enter,
.toer-leave-to {
  animation: clipCircleIn 1s ease-out forwards;
}

// 进入案例详情动画
.detail-enter-active {
  transition: all 0.5s;
}
.detail-leave-active {
  transition: all 0.5s;
}
.detail-enter,.detail-leave-to {
  transform: translate(0, 100%);
}

@keyframes clipCircleIn {
  0% {
    -webkit-clip-path: circle(100% at 50% 0%);
    clip-path: circle(100% at 50% 0%);
  }
  100% {
    -webkit-clip-path: circle(10px at 50% 0%);
    clip-path: circle(10px at 50% 0%);
  }
}

@keyframes routerPage {
  0% {
    -webkit-clip-path: circle(1% at 50% 20%);
    clip-path: circle(1% at 50% 20%);
  }
  100% {
    -webkit-clip-path: circle(100% at 50% 0%);
    clip-path: circle(100% at 50% 0%);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue